import {
  UserIcon,
  UsersIcon,
  BriefcaseIcon,
} from '@heroicons/react/24/outline';

const audiences = [
  {
    icon: UserIcon,
    title: 'Older Adults',
    description: 'For independence and confidence where life happens.',
    stat: '95%',
    statLabel: 'of people want to stay in their homes',
  },
  {
    icon: UsersIcon,
    title: 'Families',
    description: 'For clarity instead of constant worry.',
    stat: '53M',
    statLabel: 'family caregivers across the US',
  },
  {
    icon: BriefcaseIcon,
    title: 'Caregivers and Professionals',
    description: 'For alignment and clarity.',
    stat: '4.5M',
    statLabel: 'home care workers supporting independence',
  },
];

const BuiltForMajoritySection = () => {
  return (
    <div className="py-20 lg:py-28 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-6">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Designed for People Who Want to{' '}
            <span className="text-primary">Remain at Home</span>
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Built for the vast majority of people who want to remain in their
            homes, living simply, independently, and fully.
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto mt-12">
          {audiences.map((a) => (
            <div
              key={a.title}
              className="group text-center p-8 rounded-2xl bg-background border border-border shadow-sm hover:shadow-lg hover:border-primary/20 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center justify-center gap-3 mb-5">
                <div className="w-12 h-12 bg-primary/10 rounded-2xl flex items-center justify-center group-hover:bg-primary/15 transition-colors">
                  <a.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-bold text-foreground text-lg">{a.title}</h3>
              </div>
              <p className="text-3xl font-bold text-primary mb-1">{a.stat}</p>
              <p className="text-xs text-muted-foreground mb-4">{a.statLabel}</p>
              <p className="text-sm text-muted-foreground">{a.description}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-primary font-semibold text-lg mt-12">
          Different roles. One connected system.
        </p>
      </div>
    </div>
  );
};

export default BuiltForMajoritySection;
